import React from 'react';

function Manage() {
  return (
    <div>
      <h1>hello world manage</h1>
    </div>
  );
}

export default Manage;
